import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csstring(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# String tutorial For Beginners</title>
 <meta name="description" content="C# String tutorial for beginners.String in C# is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# String,c# String for,c sharp String" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-string" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">String in C#
</h1>
<div className="first">
        <a href="/csharp-namespace">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-control-structure">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">1, String in C# is the name of a memory location  in which we can store the text <br/>
2, The text  of string in Csharp can be changed <br/>
3, Text or character  enclosed  by double quotes <br/>
4, Create a variable of string type  <br/>
 <br/>
</p>



<h2 className='headings'>Q-Write a Program and print String Name in C# String example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty-5">namespace</span>
            <span className="qwerty-6"> Variable</span>
            {"\n"}
            <span className="qwerty-4">&#123;</span>
            {"\n"}
            <span className="qwerty"> class </span>
            <span className="qwerty-6">Program</span>
            {"\n"}
            <span className="qwerty-4">&#123;</span>
            {"\n"}
            <span className="qwerty-10">static </span>
            <span className="qwerty-6">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty">(</span>
            <span className="qwerty">string </span>
            <span className="qwerty-3">[] </span>
            <span className="qwerty-6">args</span>
            <span className="qwerty">)</span>
            {"\n"}
            <span className="qwerty-4">&#123;</span>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">"</span>
            <span className="qwerty-3">ram</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">; </span>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">"</span>
            <span className="qwerty-5">Lakshman</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">; </span>
            {"\n"} {"\n"}
            <span className="qwerty-1"> Or</span>
            {"\n"} {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-10">, </span>
            <span className="qwerty-7">b</span>
            <span className="qwerty">;</span>
            {"\n"}
            <span className="qwerty-7">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">"</span>
            <span className="qwerty-3">ram</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">; </span>
            {"\n"}
            <span className="qwerty-7">b</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">"</span>
            <span className="qwerty-5">Lakshman</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">; </span>
            {"\n"}
            <span className="qwerty-7">  Console</span>
            <span className="qwerty-4">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-3"> + </span>
            <span className="qwerty-1">" "</span>
            <span className="qwerty-3"> + </span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty-3"> ram </span>
            <span className="qwerty-5">Lakshman</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">C# String Uppercase and Lowercase method<br/></h2>
<h3 className="mt-4 bold mh3">ToUpper()-</h3>
<p className="mt-4 para">uppercase Method use to convert a string into an uppercase string
</p>



<h2 className='headings'>Q-Write a Program and print Uppercase in C# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3"> code </span>
            <span className="qwerty-5">exampler </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">Console</span>
            <span className="qwerty-4">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3">.</span>
            <span className="qwerty-6">ToUpper</span>
            <span className="qwerty-3"> ()</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty-3"> CODE </span>
            <span className="qwerty-5">EXAMPLER</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h3 className="mt-4 bold mh3">ToLower()- </h3>
<p className="mt-4 para">Lowercase Method use to convert a string into a lowercase string<br/>
</p>


<h2 className='headings'>Q-Write a Program and print Lowercase in C# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3"> CODE </span>
            <span className="qwerty-5">EXAMPLER</span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">Console</span>
            <span className="qwerty-4">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3">.</span>
            <span className="qwerty-6">ToLower</span>
            <span className="qwerty-3"> ()</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty-3"> code </span>
            <span className="qwerty-5">exampler </span>
            {"\n"}{"\n"}
          </code>
        </pre>
        </div>


<h3 className="mt-4 mh3">C# String Contains() Method in a string:<br/></h3>
<p className="mt-4 para">Contains () method is used to check text means substring inside a string type variable and this contains() method give output like: Boolean value
</p>



<h2 className='headings'>Q-Write a Program and print String Contains in C# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3"> CODE </span>
            <span className="qwerty-5">EXAMPLER</span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">Console</span>
            <span className="qwerty-4">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3">.</span>
            <span className="qwerty-6">Contains</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-5">EXAMPLER</span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">Console</span>
            <span className="qwerty-4">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3">.</span>
            <span className="qwerty-6">Contains</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-5">exampler </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty-3">True</span>
            {"\n"}
            <span className="qwerty-5">False </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">Csharp(C#) string length:<br/></h2>
<p className="mt-4 para"> c# string length to check the length of the string means to return the character of a string in the form of numbers</p>


<h2 className='headings'>Q-Write a Program and print in C# String length Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3"> Code </span>
            <span className="qwerty-6">Exampler</span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">Console</span>
            <span className="qwerty-4">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-5">The String length is </span>
            <span className="qwerty-1">: </span>
            <span className="qwerty-4">"+ </span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-1">.</span>
            <span className="qwerty-6">Length</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-5">The String length is </span>
            <span className="qwerty-1">: </span>
            <span className="qwerty-6">13 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">Find a C# String character:<br/></h2>


<h2 className='headings'>Q-Write a Program and print in C# string character?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3"> code </span>
            <span className="qwerty-6">exampler</span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">Console</span>
            <span className="qwerty-4">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-2">[</span>
            <span className="qwerty-4">2</span>
            <span className="qwerty-2">]</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-5">d</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">Check character by CSharp string index<br/></h2>
<h3 className="mt-4 mh3">CSharp string indexOf():</h3>
<p className="mt-4 para">CSharp string indexOf() method  use to check start index position <br/>
</p>



<h2 className='headings'>Q-Write a Program and print in Csharp string indexof()?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3"> code </span>
            <span className="qwerty-5">exampler</span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">Console</span>
            <span className="qwerty-4">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-4">a.</span>
            <span className="qwerty-6">IndexOf</span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-5">exampler</span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty-5">5</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">C# Substring<br/></h2>
<p className="mt-4 para">Return a substring from this instance.
</p>


<h2 className='headings'>Q-Write a Program and print in C# Substring Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3"> code </span>
            <span className="qwerty-5">exampler</span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">Console</span>
            <span className="qwerty-4">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-4">a.</span>
            <span className="qwerty-6">Substring</span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-5">5</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty-5">exampler</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className='headings'>Q-Write a Program and print in C# Substring Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3"> code </span>
            <span className="qwerty-5">exampler</span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">Console</span>
            <span className="qwerty-4">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-4">a.</span>
            <span className="qwerty-6">Substring</span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-5">2, 8</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty-5">de</span>
            {"\n"}
            <span className="qwerty-4">examp</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2"> Add a string with integer:<br/></h2>


<h2 className='headings'>Q-Write a Program and print in String format in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3"> 20 </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-2">b</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-5"> CodeExampler </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-2">c</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3"> + </span>
            <span className="qwerty-2">b</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">Console</span>
            <span className="qwerty-4">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-2">c</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty-3"> 20</span>
            <span className="qwerty-5">CodeExampler</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">Convert C# string to int:<br/></h2>
<h3 className="mt-4 mh3">CSharp string to int topic is very important<br/> </h3>


<h2 className='headings'>Q-Write a Program and print and Simple String format in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty">String </span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3"> 10 </span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">Console</span>
            <span className="qwerty-4">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty-3"> 10</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h3 className="mt-4 mh3">But when you Convert c# string to int:

</h3>


<h2 className='headings'>Q-Write a Program and Convert C# string to int?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty">int </span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">Convert</span>
            <span className="qwerty-3">.ToInt32</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">20</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4">Console</span>
            <span className="qwerty-5">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-2">a</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty-3"> 20</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className='headings'>Q-Write a Program and print User Input an Int Value in Csharp Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">Console</span>
            <span className="qwerty-6">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-5">input a no</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty">Int </span>
            <span className="qwerty-5">x</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">Console</span>
            <span className="qwerty-3">.ReadLine</span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4">Console</span>
            <span className="qwerty-6">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">x</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty-3"> Error</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<p className="mt-4 para"> when you compile this program Show error because of<span className="bold"> Console.ReadLine();</span>  cannot implicitly  convert  type ‘string to ‘int’ and also  gives a string  value not int so we convert this into an integer</p>



<h2 className='headings'>Q-Write a Program and print User input an integer number in Csharp Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code>
            {"\n"}
            <span className="qwerty-4">Console</span>
            <span className="qwerty-6">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-5">input a no</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty">int </span>
            <span className="qwerty-5">x</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-7">Convert</span>
            <span className="qwerty-3">.ToInt32</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">Console</span>
            <span className="qwerty-3">.ReadLine</span>
            <span className="qwerty-7">()</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4">Console</span>
            <span className="qwerty-6">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">x</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">input a no</span>
            {"\n"}
            <span className="qwerty-3"> 4</span>
            {"\n"}{"\n"}
            <span className="qwerty-7">Answer-</span>
            {"\n"}
            <span className="qwerty-3"> 4</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h3 className="mt-4 mh3">when you convert string to double:</h3>
<p className="mt-4 para">If you print decimal no so you use 
</p>



<h2 className='headings'>Q-Write a Program and print User input an double number in C# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">Console</span>
            <span className="qwerty-6">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-5">input a no</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty">double </span>
            <span className="qwerty-5">x</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-7">Convert</span>
            <span className="qwerty-3">.ToDouble</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">Console</span>
            <span className="qwerty-3">.ReadLine</span>
            <span className="qwerty-7">()</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4">Console</span>
            <span className="qwerty-6">.WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">x</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      <h2 className='headings'>Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">input a no</span>
            {"\n"}
            <span className="qwerty-3"> 4.5</span>
            {"\n"}{"\n"}
            <span className="qwerty-7">Answer-</span>
            {"\n"}
            <span className="qwerty-3"> 4.5</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-namespace"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-control-structure"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csstring;